import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectComponentsRoute: InvariantJiraRoute = {
	name: 'project-components',
	path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/components',
};
